import { render } from "./BlueBack.svg?vue&type=template&id=62fe8f62"
const script = {}
script.render = render

export default script